import { ChartLineUpIcon } from '@phosphor-icons/react/dist/csr/ChartLineUp'
import { FileArrowUpIcon } from '@phosphor-icons/react/dist/csr/FileArrowUp'
import { KanbanIcon } from '@phosphor-icons/react/dist/csr/Kanban'
import { PackageIcon } from '@phosphor-icons/react/dist/csr/Package'
import { PlusIcon } from '@phosphor-icons/react/dist/csr/Plus'

import type { PhosphorIcon } from '@/types/picture'
import {
  ONBOARDING_OBJECTIVE,
  ONBOARDING_START_MODE,
  type OnboardingObjective,
  type OnboardingStartMode,
} from '@/types/onboarding'

export const MANAGE_ONBOARDING_PREF_KEY = 'manage-onboarding-v1'
export const ONBOARDING_PATH = '/onboarding'
export const ONBOARDING_BACKGROUND_IMAGE = '/img/welcome-background.png'

export const MODES: {
  id: OnboardingStartMode
  icon: PhosphorIcon
  titleKey: string
  descriptionKey: string
}[] = [
  {
    id: ONBOARDING_START_MODE.import,
    icon: FileArrowUpIcon,
    titleKey: 'resource-start-import-title',
    descriptionKey: 'resource-start-import-description',
  },
  {
    id: ONBOARDING_START_MODE.scratch,
    icon: PlusIcon,
    titleKey: 'resource-start-scratch-title',
    descriptionKey: 'resource-start-scratch-description',
  },
]

export const OBJECTIVES: {
  id: OnboardingObjective
  icon: PhosphorIcon
  titleKey: string
  descriptionKey: string
}[] = [
  {
    id: ONBOARDING_OBJECTIVE.planProjects,
    icon: KanbanIcon,
    titleKey: 'objective-plan-title',
    descriptionKey: 'objective-plan-description',
  },
  {
    id: ONBOARDING_OBJECTIVE.visibility,
    icon: ChartLineUpIcon,
    titleKey: 'objective-visibility-title',
    descriptionKey: 'objective-visibility-description',
  },
  {
    id: ONBOARDING_OBJECTIVE.resources,
    icon: PackageIcon,
    titleKey: 'objective-resources-title',
    descriptionKey: 'objective-resources-description',
  },
]

export const onboardingBorder = {
  modal: 'shadow-[0_12px_40px_-16px_rgba(15,23,42,0.1),0_0_0_1px_#ebebeb]',
  divider: 'border-neutral-200/70',
  card: 'shadow-[0_0_0_1px_#e5e5e5]',
  cardHover: 'hover:shadow-[0_0_0_1px_#d4d4d4]',
  cardSelected: 'shadow-[0_0_0_1px_#ffdd96]',
  ring: 'border border-neutral-300/90',
  ringActive: 'border-2 border-primary-500',
}

export const onboardingSurface = {
  cardSelected: 'bg-[#fffbf0]',
  icon: 'bg-neutral-100',
  iconSelected: 'bg-primary-100',
  sidebar: 'bg-[#f6f7f9]',
  sidebarStepHover:
    'hover:bg-[#eceef2] active:bg-[#eceef2] focus-visible:bg-[#eceef2]',
}

export const onboardingMotion = {
  dialog: 'motion-safe:animate-onboarding-dialog-in motion-reduce:animate-none',
}

export const onboardingLayout = {
  pagePadding: 'p-4 sm:p-6',
  shellPadding: 'px-6 py-8',
  footerPadding: 'px-6 py-5',
  mobileHeaderPadding: 'px-6 py-4',
  contentGap: 'mt-8',
  contentMaxWidth: 'max-w-2xl',
}

let onboardingEntranceAnimationConsumed = false

export const consumeOnboardingEntranceAnimation = (): boolean => {
  if (onboardingEntranceAnimationConsumed) return false
  onboardingEntranceAnimationConsumed = true
  return true
}

export const resetOnboardingEntranceAnimationForTests = (): void => {
  onboardingEntranceAnimationConsumed = false
}

export const ONBOARDING_BYPASS_PATH_PREFIXES = ['/account', '/onboarding']

export const isPathAllowedDuringOnboarding = (pathname: string): boolean => {
  if (
    pathname === ONBOARDING_PATH ||
    pathname.startsWith(`${ONBOARDING_PATH}/`)
  ) {
    return true
  }
  return pathname === '/account' || pathname.startsWith('/account/')
}
